import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'showNumberOfItem' })
export class ShowNumberOfItem implements PipeTransform {
  transform(item: string, n: number ): string {
    return n ? `${item} (${n})` : item;
  }
}
